import { lazy, Suspense, useState } from "react";
import { InfoDialog } from "./InfoDialog";

/**
 * The in-app player feedback control (GRA-102): a small keyboard-accessible
 * trigger, in the footer, that opens the shared InfoDialog shell around a
 * compact form. Free text only, no identity or contact fields, matching the
 * ticket's privacy guardrail. Reuses InfoDialog rather than a bespoke modal
 * so it gets the same Escape/backdrop/focus behavior as every other dialog
 * in the app for free.
 *
 * The trigger below sits in the footer on every load; the form itself (with
 * its Turnstile widget loader, lib/turnstile.ts) is split into its own chunk
 * (FeedbackForm.tsx) and only fetched once a player actually opens it.
 */
const FeedbackForm = lazy(() => import("./FeedbackForm"));

export function FeedbackButton({
  className = "flex min-h-8 items-center rounded border border-muted/30 px-2 py-1 text-xs text-muted transition-colors hover:border-accent hover:text-accent sm:min-h-6",
}: {
  /** Overrides the trigger's own styling; the dialog it opens never changes. */
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={className}>
        feedback
      </button>
      {open && (
        <InfoDialog title="feedback" size="wide" onClose={() => setOpen(false)}>
          <Suspense fallback={<p className="text-sm text-muted">loading…</p>}>
            <FeedbackForm onClose={() => setOpen(false)} />
          </Suspense>
        </InfoDialog>
      )}
    </>
  );
}
